module.exports = __webpack_public_path__ + "img/highlights-carousel01.be4be8ec.png";